import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['databaseTable'] = {
  databaseTableCell: {
    capabilitiesCell: {
      components: {
        redisStackView: {
          text: {
            color: themeUi.semantic.color.text.secondary200
          },
          nextStepsText: {
            color: themeUi.semantic.color.text.neutral700
          },
          description: {
            color: themeUi.semantic.color.text.secondary50
          },
          moduleName: {
            color: themeUi.semantic.color.text.secondary50
          },
          tooltipContainerWrapper: {
            backgroundColor: themeUi.semantic.color.text.informative50
          },
          tooltipActionContainer: {
            backgroundColor: themeUi.semantic.color.text.neutral100
          },
          tooltipTitle: {
            color: themeUi.semantic.color.text.neutral700
          },
          explanationText: {
            color: themeUi.semantic.color.text.neutral800
          },
          connectText: {
            color: themeUi.semantic.color.text.neutral800
          },
          connectButton: {
            backgroundColor: themeUi.semantic.color.text.primary600
          }
        }
      }
    },

    bdbEndpointCell: {
      components: {
        firstDatabaseCongratulations: {
          closeIcon: {
            color: themeUi.semantic.color.icon.neutral700
          }
        }
      }
    },

    bdbStatusCell: {
      networkMemoryUsageAlert: {
        closeIcon: {
          color: themeUi.semantic.color.icon.neutral700
        },
        errorIndicator: {
          warning: themeUi.semantic.color.text.attention500,
          danger: themeUi.semantic.color.text.danger500,
          critical: themeUi.semantic.color.text.danger900
        }
      }
    },

    crdbOptionsCell: {
      components: {
        crdbOptionBadgeTooltipContent: {
          regionItem: {
            backgroundColor: themeUi.semantic.color.background.neutral300
          }
        }
      }
    },

    crdbThroughputTooltip: {
      components: {
        throughputTooltipContent: {
          container: {
            color: themeUi.semantic.color.text.secondary200
          },
          title: {
            color: themeUi.semantic.color.text.secondary200
          },
          throughputText: {
            color: themeUi.semantic.color.text.secondary200
          },
          tfootText: {
            color: themeUi.semantic.color.text.secondary200
          }
        }
      }
    },

    dbActionsMenuCell: {
      components: {
        dbActionsMenu: {
          iconButtonTrigger: {
            backgroundColor: themeUi.semantic.color.background.primary100
          }
        }
      }
    }
  }
};

export default theme;
